import { useEffect } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

function RequireAuth({ authenticated, children }) {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!authenticated) {
            navigate(
                {
                    pathname: "/login",
                    search: location.search || "",
                    hash: location.hash || "",
                },
                {
                    replace: true, 
                    state: {
                        nextPath: `${location.pathname}${location.search}${location.hash}`,
                    },
                }
            );
        }
    }, [authenticated, location.pathname, location.search, location.hash, navigate]);

    if (!authenticated) return null;
    return children;
}

const mapStateToProps = (state) => ({
    authenticated: state.auth.authenticated,
});

export default connect(mapStateToProps, {})(RequireAuth);